type Options = {
  min?: number;
  max?: number;
  defaultValue?: number;
};

export const toNumber = (
  data: unknown,
  { min = -Infinity, max = Infinity, defaultValue }: Options = {}
): number => {
  if (!data && typeof data !== 'number') {
    return defaultValue;
  }

  return Math.max(Math.min(Number(data), max), min);
};
